export const getFormattedLocation = location => {
  if (!location) {
    return "";
  }
  return `${location.line1}, ${location.line2}, ${location.line3}`;
};

export const locationUtils = {
  getFormattedLocation
};
